// Shared role → post-login dashboard route mapping.
// Single source of truth for login-authentication and auth-callback so the
// two entry points can never drift apart.

export const getRouteForRole = (role) => {
  const r = (role || '')?.toLowerCase()?.trim()?.replace(/ /g, '_');
  if (r === 'buyer' || r === 'sugar_buyer') return '/buyer-operations-dashboard';
  if (r === 'seller' || r === 'quota_manager' || r === 'quotamanager' || r === 'sugar_quota_seller') return '/quota-allocation-pricing-center';
  if (r === 'factory' || r === 'factory_admin') return '/factory-management-hub';
  if (r === 'transporter') return '/transporter-dashboard';
  if (r === 'sales_agent') return '/sales-agent-dashboard';
  if (r === 'admin') return '/admin-dashboard';
  if (r === 'monitor') return '/monitor-dashboard';
  if (r === 'factory_relations_officer') return '/factory-rate-intelligence-center';
  return '/buyer-operations-dashboard';
};

// Returns a safe internal redirect target from the current URL's ?next= param,
// or null when absent or unsafe. Only same-app relative paths are allowed —
// external URLs, protocol-relative URLs and backslash tricks are rejected so a
// crafted link cannot redirect a logged-in user off-site after auth.
export const getPostLoginRedirect = () => {
  try {
    const next = new URLSearchParams(window.location?.search)?.get('next');
    if (!next) return null;
    if (!next.startsWith('/') || next.startsWith('//') || next.includes('\\')) return null;
    if (next.startsWith('/login-authentication')) return null; // avoid redirect loops
    return next;
  } catch (e) {
    return null;
  }
};
